import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/695cd1737683ed00149363b7/samkit_agro_corporate/src/components/common/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/695cd1737683ed00149363b7/samkit_agro_corporate/src/components/common/Header.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/695cd1737683ed00149363b7/samkit_agro_corporate/src/styles/index.css");
